import { Button, Grid } from '@material-ui/core';
import en from '../../../../lang/en-us';
import TextInput from '../../../../lib/TextField';
import { UploadFile } from '../../../../lib/UploadFile.tsx';
const { dashboard } = en;
import { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { ConsolidateTableRowType } from '../ConsolidationFolios/types';
import { RootStateType } from '../../../../redux-store/reducers';
import { sendPhoneOTP, onSaveImageData } from '../../../../redux-store/actions/nct';
import { MINOR_MAJOR, OTP_ACTIONS } from '../../../../utils/constants';
import { BANK, ImageSaveType } from '../../../../redux-store/types/nct';
import { ActionHeader, FaqLink } from '..';
import { findDefaultBank } from '../ChangeBank';

export function MinorStatusReview(props: any) {
    const { Funds, newPan, nomineeData } = props.location.state || {};
    const [targetFunds, setTargetFunds] = useState<ConsolidateTableRowType[]>([]);
    const [images, setImages] = useState({
        pan: { name: 'pan', format: '', content: '' },
        cheque: { name: 'NewCheque', format: '', content: '' },
        signature: { name: 'First holder signature', format: '', content: '' },
    });
    const { bank: bankList = [] } = Funds[0] || {};
    const defaultBank = findDefaultBank(Funds[0]);
    useEffect(() => {
        if (!props.location.state) {
            props.history.push('/');
            return;
        }
        setTargetFunds(Funds);
    });

    // save image in store
    useEffect(() => {
        return () => {
            const imageInfo: ImageSaveType = {
                data: Object.values(images),
                type: 'MINOR_TO_MAJOR',
            };
            props.onSaveImageData(imageInfo);
        };
    }, [images]);

    const handleSubmit = async () => {
        const { pan, pekrn, mobile } = props;
        try {
            let res = await props.sendPhoneOTP({
                mobile,
                pan,
                pekrn,
                action: OTP_ACTIONS.minorStatusChange,
            });
            let payload = {
                ...(res || {}).body,
                mobile,
                // images: Object.values(images), // handling in redux
                pan,
                pekrn,
                newPan,
            };
            let data = targetFunds.map((_ele: ConsolidateTableRowType, index: number) => ({
                folio: _ele.folio,
                amc: _ele.amc,
                name: _ele.investorName,
                dob: _ele.dob,
                bankDetails: { ...findDefaultBank(_ele) },
                guardian: _ele.guardian,
            }));

            props.history.replace('minor-status-otp', { ...payload, data });
        } catch (err: any) {
            alert(err.message);
        }
    };
    return (
        <div className="curved-bg">
            <ActionHeader header={dashboard.MinorStatus.MinorStatusHeading} />
            <div className="curved-bg-content update-pan-selected-content">
                <div className="curved-bg-content-inner minor-review">
                    <div className="curved-bg-content-inner-top">
                        <p>{dashboard.MinorStatus.ReviewDetails.subheading}</p>
                        <div className="selected-folios-list">
                            <h3>
                                {!!targetFunds.length ? defaultBank?.name : 'Bank Name'}
                            </h3>
                            <a
                                className="edit-folio"
                                onClick={() =>
                                    props.history.push('minor-status-edit-bank', {
                                        Funds: targetFunds,
                                        defaultBank,
                                        newPan,
                                    })
                                }
                            >
                                <img src="/images/edit-fill-purple.svg" alt="delete icon" />
                            </a>
                            <div className="curved-table-filters-selected">
                                <div className="curved-table-filters-selected-tags">
                                    <p>Folios: </p>
                                    <div className="tags">
                                        {targetFunds.map(
                                            (_ele: ConsolidateTableRowType, index: number) => (
                                                <span>{_ele.folio}</span>
                                            ),
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="selected-folios-list-bottom">
                                {!!targetFunds.length && (
                                    <>
                                        <p>
                                            {dashboard.MinorStatus.ReviewDetails.accountNo}
                                            <span>{defaultBank?.accountNo || 'NA'}</span>
                                        </p>
                                        <p>
                                            {dashboard.MinorStatus.ReviewDetails.ifsc}
                                            <span>{defaultBank?.ifsc || 'NA'}</span>
                                        </p>
                                        <p>
                                            {dashboard.MinorStatus.ReviewDetails.accountType}
                                            <span>
                                                {defaultBank?.accountType || 'NA'}
                                            </span>
                                        </p>
                                    </>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="curved-bg-content-inner-bottom">
                        <div className="selected-folios-btn minor-status-folios-bottom">
                            <Grid container spacing={3}>
                                <Grid item xs={12} lg={6}>
                                    <h4>{dashboard.MinorStatus.ReviewDetails.uploadPanHeading}</h4>
                                    <UploadFile
                                        onImageSelected={(value, format) => {
                                            setImages({
                                                ...images,
                                                pan: {
                                                    ...images.pan,
                                                    format: format,
                                                    content: value,
                                                },
                                            });
                                        }}
                                        id={'pan'}
                                    />
                                </Grid>
                                <Grid item xs={12} lg={6}>
                                    <h4>
                                        {dashboard.MinorStatus.ReviewDetails.uploadChequeHeading}
                                    </h4>
                                    <UploadFile
                                        onImageSelected={(value, format) => {
                                            setImages({
                                                ...images,
                                                cheque: {
                                                    ...images.cheque,
                                                    format: format,
                                                    content: value,
                                                },
                                            });
                                        }}
                                        id={'cheque'}
                                    />
                                </Grid>
                                <Grid item xs={12}>
                                    <h4>
                                        {dashboard.MinorStatus.ReviewDetails.uploadSignatureHeading}
                                    </h4>
                                    <p>{dashboard.MinorStatus.ReviewDetails.uploadSignatureInfo}</p>
                                    <div className="minor-status-upload-fields">
                                        <UploadFile
                                            onImageSelected={(value, format) => {
                                                setImages({
                                                    ...images,
                                                    signature: {
                                                        ...images.signature,
                                                        format: format,
                                                        content: value,
                                                    },
                                                });
                                            }}
                                            id={'signature'}
                                        />
                                        <p>
                                            <span
                                                style={{ cursor: 'pointer' }}
                                                onClick={() => {
                                                    window.open(
                                                        `${process.env.REACT_APP_S3_CLOUD_URL}/MAMForm-forchangeinstatusfromMinortoMajor.pdf`,
                                                        "_system"
                                                    );
                                                }}
                                            >
                                                {
                                                    dashboard.MinorStatus.ReviewDetails
                                                        .uploadSignatureLink
                                                }
                                            </span>
                                            {
                                                dashboard.MinorStatus.ReviewDetails
                                                    .uploadSignatureLinkInfo
                                            }
                                        </p>
                                    </div>
                                </Grid>
                            </Grid>
                        </div>
                        <FaqLink section={MINOR_MAJOR} history={props.history} />
                        <Button
                            style={{ margin: 'auto' }}
                            onClick={handleSubmit}
                            className="customBtn"
                            disabled={!Object.values(images).every((_ele: any) => !!_ele.content)}
                        >
                            {dashboard.MinorStatus.ReviewDetails.buttonText}
                        </Button>
                    </div>
                </div>
            </div>
        </div>
    );
}
export default connect(({ authReducer }: RootStateType) => ({ ...authReducer }), {
    sendPhoneOTP,
    onSaveImageData,
})(MinorStatusReview);
